/**
 * Display-local workspace loading flag.
 *
 * Lives OUTSIDE the mirrored canvas-store on purpose: it is per-window view
 * state (the owner's REST frame load spinner) and must NOT cross the mirror
 * boundary. The owner-connection hook writes it; the workspace views read it
 * for their loading state. Not registered in store-snapshot.ts.
 */
import { create } from "zustand";

interface WorkspaceLoadState {
  /** True while the owner is fetching the current space's frames via REST. */
  isLoadingCanvas: boolean;
  /** Space id whose frame list has been applied to the canvas store. */
  framesLoadedSpaceId: string | null;
  /** Space id whose frames the owner has fully loaded (null = none yet). Used
   *  by the snapshot service to avoid serializing before the load completes. */
  loadedSpaceId: string | null;
  setIsLoadingCanvas: (loading: boolean) => void;
  setFramesLoadedSpaceId: (id: string | null) => void;
  setLoadedSpaceId: (id: string | null) => void;
}

export const useWorkspaceLoadStore = create<WorkspaceLoadState>()((set) => ({
  isLoadingCanvas: false,
  framesLoadedSpaceId: null,
  loadedSpaceId: null,
  setIsLoadingCanvas: (loading) => set({ isLoadingCanvas: loading }),
  setFramesLoadedSpaceId: (id) => set({ framesLoadedSpaceId: id }),
  setLoadedSpaceId: (id) => set({ loadedSpaceId: id }),
}));
